import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SidebarState {
    show: boolean;
    isMobile: boolean;
    layoutMask: boolean;
}

const initialState: SidebarState = {
    show: true,
    isMobile: false,
    layoutMask: window.innerWidth > 991 ? false : true,
};

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.show = !state.show;
        },
        setSidebarVisibility: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        toggleMobile: (state,action: PayloadAction<boolean>) => {
            state.isMobile = action.payload;
        },
        toggleLayoutMask: (state, action: PayloadAction<boolean>) => {
            state.layoutMask = action.payload;
        }
    },
});

export const {toggleSidebar, setSidebarVisibility, toggleMobile, toggleLayoutMask} = sidebarSlice.actions;

export default sidebarSlice.reducer;